import { i18n } from '@/commons/utils';

const getWoosmapStoreInfos = idstore => new Promise(resolve => cube.stores.searchStores({ idstore }, resolve));

export const init = () => {
  const storeId = cube.$('[data-store-id]') && cube.$('[data-store-id]').dataset.storeId;

  if (storeId) getWoosmapStoreInfos(storeId).then(response => {
    const store = response[0].properties;

    cube.$('.opening-hours').$$('.day').forEach((item, index) => {
      const day = store.weekly_opening[index + 1];
      let schedule = '';

      if (day.hours.length) {
        if (day.hours[0]) schedule += `${day.hours[0].start} - ${day.hours[0].end}`;
        if (day.hours[1]) schedule += ` / ${day.hours[1].start} - ${day.hours[1].end}`;
      } else schedule = i18n('mystore.dashboard.closed');

      item.innerHTML = item.innerHTML.replace('...', schedule);
    });
  });
};



// WEBPACK FOOTER //
// ./src/checkout/confirmation/get-store-infos.js